












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Truncate extends Vue {
  @Prop() text: string;

  @Prop() maxLength: number;

  get truncatedText() {
    if (this.text.length > this.maxLength) {
      return this.text.slice(0, this.maxLength) + '...';
    }
    return this.text;
  }
}
